package com.anjuros.website.templates.template1.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.template1.components.Template1SectionTitle
import com.anjuros.website.templates.template1.modules.Template1Price
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.styles.Template1PriceColorStyle
import com.anjuros.website.templates.template1.styles.Template1SectionPaddingStyle
import com.anjuros.website.templates.template1.util.ResKey
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.P


@Composable
fun Template1PriceSection(){
    Box(modifier = Template1SectionPaddingStyle.toModifier()
        .id(Template1Section.Prices.id)
        .fillMaxWidth()
        .backgroundColor(Template1Theme.DarkGrey.rgb),
        contentAlignment = Alignment.Center) {

        Template1PriceContent()
    }
}

@Composable
private fun Template1PriceContent(){
    Column(
        modifier = Modifier
            .fillMaxWidth(90.percent)
            .maxWidth(700.px)
            .margin(leftRight = 10.px)
    ) {
        Box(modifier = Modifier.margin(bottom = 64.px)) {
            Template1SectionTitle(
                badge = ResKey.TEMPLATE1_PRICES_BADGE,
                title = ResKey.TEMPLATE1_PRICES_TITLE,
                text = ResKey.TEMPLATE1_SERVICE_DESC2,
                darkMode = true
            )
        }
        Template1Price.entries.forEach {

            Template1PriceItem(it)

        }

    }
}

@Composable
private fun Template1PriceItem(
    item: Template1Price
) {

    Row(
        modifier = Template1PriceColorStyle.toModifier()
            .fillMaxWidth()
            .padding(topBottom = 22.px, leftRight = 4.px)
            .borderBottom(
                1.px,
                LineStyle.Solid,
                rgb(235,235,235)
            ),
        verticalAlignment = Alignment.CenterVertically
    ) {

        SpanText(
            LocalText(item.title),
            Modifier
                .fontSize(20.px)
                .fontWeight(FontWeight.Medium)
                .color(Colors.White)
        )

        Spacer()

        P( attrs =  Modifier
            .fontSize(20.px)
            .margin(topBottom = 0.px)
            .fontWeight(FontWeight.Bold)
            .color(Template1Theme.Primary.getColor()).toAttrs()){
            AnjurosText(
                item.price,
                com.anjuros.website.components.language.ResKey.PLACEHOLDER_SERVICE_PRICE
              )
        }
    }
}